"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.P = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var TypographyCSS_1 = require("./TypographyCSS");

exports.P = styled_components_1.default.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 300;\n  white-space: pre-wrap;\n  ", "\n"])), TypographyCSS_1.TypographyCSS);